import { gsap } from "gsap";
import MorphSVGPlugin from "gsap/MorphSVGPlugin";

gsap.registerPlugin(MorphSVGPlugin);

export const init = () => {
  const svg = document.querySelector("#pixel-logo-txt");
  if (!svg) return;

  const container = svg.closest(".svg-container") || svg;

  let morphType = "linear";

  const animations = [];

  animations.push(
    gsap.to("#pixel-logo-l", {
      morphSVG: {
        shape: "#pixel-p",
        type: morphType,
      },
      duration: 2,
      ease: "expo.inOut",
      paused: true,
    })
  );

  animations.push(
    gsap.to("#pixel-logo-t", {
      morphSVG: {
        shape: "#pixel-i",
        type: morphType,
      },
      duration: 2,
      ease: "expo.inOut",
      paused: true,
    })
  );

  animations.push(
    gsap.to("#pixel-logo-ba", {
      morphSVG: {
        shape: "#pixel-x",
        type: morphType,
      },
      opacity: 1,
      duration: 2,
      ease: "expo.inOut",
      paused: true,
    })
  );

  animations.push(
    gsap.to("#pixel-logo-r", {
      morphSVG: {
        shape: "#pixel-e",
        type: morphType,
      },
      opacity: 1,
      duration: 2,
      ease: "expo.inOut",
      paused: true,
    })
  );

  animations.push(
    gsap.to("#pixel-logo-bt", {
      morphSVG: {
        shape: "#pixel-l",
        type: morphType,
      },
      opacity: 1,
      duration: 2,
      ease: "expo.inOut",
      paused: true,
    })
  );

  const handleEnter = () => {
    animations.forEach((animation) => {
      animation.play();
    });
  };

  const handleLeave = () => {
    animations.forEach((animation) => {
      animation.reverse();
    });
  };

  container.addEventListener("mouseenter", handleEnter);
  container.addEventListener("mouseleave", handleLeave);
};
